<div class="scss-website-background-color">
    @switch (Scope.websiteMode) {
        @case (WebsiteMode.Live) {
            <div class="d-flex position-relative design-block">
                <ng-container *ngTemplateOutlet="blockContent"></ng-container>
            </div>
        }
        @case (WebsiteMode.ReadOnly) {
            <div class="d-flex position-relative design-block">
                <ng-container *ngTemplateOutlet="blockContent"></ng-container>
            </div>
        }
        @case (WebsiteMode.Preview) {
            <lib-design-blocks-action-menu>
                <ng-container *ngTemplateOutlet="blockContent"></ng-container>
            </lib-design-blocks-action-menu>
        }
    }
</div>

<ng-template #blockContent>
    <div class="w-100 d-flex scss-spacing-html-block align-items-center">
        <ng-content></ng-content>
        @if (Scope.websiteMode !== WebsiteMode.Live) {
            <div class="design-building-block-overlay"
                (dblclick)="Scope.HandleBlockAction(websiteBlockData, WebsiteBlockAction.Edit)">
            </div>
        }
    </div>
</ng-template>